import React from "react";

const AuthLayout = ({ children }) => {
  return <div>{children}</div>;  // No Header & Footer here
};

export default AuthLayout;
